import { injectIntl } from "react-intl";
import { Alert, Drawer, IconButton, Stack, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { getMessageString } from "../../utility";
import { INSRIMENTO_FAILED, INSRIMENTO_FAILED_HELP } from "../../modules/language";

export const InserimentoError = injectIntl(({ intl, open, onClose }) => (
  <Drawer anchor="top" open={open} className="inserimentoErrorDrawer">
    <Alert
      severity="error"
      variant="filled"
      action={
        <IconButton title="Chiudi" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      }
    >
      <Stack>
        <Typography>{getMessageString(intl, INSRIMENTO_FAILED)}</Typography>
        <Typography>
          {getMessageString(intl, INSRIMENTO_FAILED_HELP)}
          <a href="mailto: scuoladigitale@regione.liguria.it"> scuoladigitale@regione.liguria.it</a>
        </Typography>
      </Stack>
    </Alert>
  </Drawer>
));
